import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Setting } from 'assets/svg/icon-setting.svg'

function IconSetting(props: IconProps): JSX.Element {
  const title = 'icon-setting'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Setting {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconSetting
